export default __webpack_public_path__ + "static/media/qukes-quick-pickles.d01ca60f.jpg";